import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Journey } from '@lighty';
import { switchMap } from 'rxjs/operators';

@Component({
    selector: 'msc-learn-detail-journey-discussion',
    templateUrl: './discussion.component.html'
})
export class LearnDetailJourneyDiscussionComponent implements OnInit {
    public journey: Journey;
    public pagination: any;

    constructor(private route: ActivatedRoute) {}

    // route.parent.data.journey ya no es el objeto Journey directo -- es { journey$ }
    // (JourneyResolver ya no bloquea la navegación, ver learn.resolver.ts).
    ngOnInit(): void {
        this.route.parent.data.pipe(
            switchMap((data: any) => data.journey.journey$)
        ).subscribe((journey: any) => {
            this.journey = journey;
        });
    }
}
